export default __webpack_public_path__ + "static/Philipp-13bf7deeb6843825d596a8ecbd4edda7.png";